import React from 'react'
import { useSelector } from 'react-redux'
import lodash from 'lodash'
import moment from 'moment'

import { OrganizationCard } from '../OrganizationCard'
import { SectionBlock } from '../SectionBlock'

import { useStyles } from './OrganizationSection.style'

const OrganizationSection = () => {
  const classes = useStyles()

  const { championship } = useSelector((state) => state.championships)

  const { organization, events } = championship

  const organizationSorted = lodash.uniqBy(
    [
      {
        ...organization,
        organizationId: organization.id,
        organizationProfileImages: organization.profileImages
      },
      ...events
        .sort(
          (a, b) =>
            moment(a.from).diff(moment(b.from)) ||
            a.name.toLowerCase().trim().localeCompare(b.name.toLowerCase().trim())
        )
        .flatMap(
          (e) =>
            e.organizations
              .filter((x) => !!x.acceptedAt)
              .map((x) => ({
                ...x,
                id: x.organizationId,
                name: x.organizationName
              })) || []
        )
    ],
    'organizationId'
  )

  return (
    <SectionBlock title='Organiza' className={classes.container}>
      <div className={classes.organizationsContainer}>
        {organizationSorted.map((e) => (
          <OrganizationCard key={e.id} organization={e} />
        ))}
      </div>
    </SectionBlock>
  )
}

export default OrganizationSection
